export default __webpack_public_path__ + "static/media/wrench.d0f6ded3.svg";